import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import ladiesbag from "../images/Ladies_bag.jpg";
import roomfreshner from "../images/room freshner.jpg";
import trolleybag from "../images/Troly Bag.jpg";
import schoolbag from "../images/school_bag.jpg";

import money_bag from "../images/Money_bag.jpg";
import chandraboti from "../images/Chandraboti Brand.jpg";
import Cosmetics from "../images/cosmentics.jpg";


function Accessories() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className='nadiacloth'>
                <div className="album py-1">
                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Accessories</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

            <div className="album py-2">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <a href='LadiesBag'>
                                        <div className="card">
                                            <img src={ladiesbag} className="card-img-top" alt="ladiesbag" />
                                            <div className="card-body">
                                                <div className='colortitle'>

                                                    <h5 className="card-title mb-1">Ladies Bag</h5>
                                                </div>
                                                <p className="card-text">Branded & Luxury Ladies Bag Available</p>
                                                <a href="LadiesBag" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                </svg></a>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="col-md-6 me-2 mt-3">
                                    <a href='#'>
                                        <div className="card">
                                            <img src={roomfreshner} className="card-img-top" alt="roomfreshner" />
                                            <div className="card-body">
                                                <div className='colortitle'>

                                                    <h5 className="card-title mb-1">Room Freshner</h5>
                                                </div>
                                                <p className="card-text">Branded roomfreshner Products Available</p>
                                                <a href="#" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                </svg></a>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                            </div>

                        </div>

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6  me-2 mt-3">
                                    <a href='trolley-bag'>
                                        <div className="card" >

                                            <img src={trolleybag} className="card-img-top" alt="trolleybag" />
                                            <div className="card-body">
                                                <div className='colortitle'>
                                                    <h5 className="card-title mb-1">Trolley Bag </h5>
                                                </div>
                                                <p className="card-text">Best Luggage bag available</p>
                                                <a href="trolley-bag" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                </svg></a>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                                <div className="col-md-6 me-2 mt-3">
                                    <a href='school-bag'>
                                        <div className="card">
                                            <img src={schoolbag} className="card-img-top" alt="schoolbag" />
                                            <div className="card-body">
                                                <div className='colortitle'>
                                                    <h5 className="card-title mb-1">School Bag</h5>
                                                </div>
                                                <p className="card-text">Best School bag available</p>
                                                <a href="school-bag" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                </svg></a>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="album py-2">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <a href='wallet'>
                                        <div className="card">
                                            <img src={money_bag} className="card-img-top" alt="money_bag" />
                                            <div className="card-body">
                                                <div className='colortitle'>

                                                    <h5 className="card-title mb-1">Wallet Bag</h5>
                                                </div>
                                                <p className="card-text">Branded Wallet Bag Available</p>
                                                <a href="wallet" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                </svg></a>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                                <div className="col-md-6 me-2 mt-3">
                                    <a href='Chandraboti'>
                                        <div className="card">
                                            <img src={chandraboti} className="card-img-top" alt="chandraboti"/>
                                            <div className="card-body">
                                                <div className='colortitle'>

                                                    <h5 className="card-title mb-1">Chandraboti</h5>
                                                </div>
                                                <p className="card-text">Chandraboti Brand Available</p>
                                                <a href="walleChandraboti" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                </svg></a>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>

                        </div>
 <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6  me-2 mt-3">
                                    <a href='Cosmetics'>
                                        <div className="card" >

                                            <img src={Cosmetics} className="card-img-top" alt="Cosmetics"/>
                                            <div className="card-body">
                                                <div className='colortitle'>
                                                    <h5 className="card-title mb-1">Cosmetics </h5>
                                                </div>
                                                <p className="card-text">Best Cosmetics bramd available</p>
                                                <a href="Cosmetics" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                </svg></a>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                                

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className="album py-1">
                <div className="container">
                    <h4>Update soon</h4>
                </div>

            </div>
            <br />
        </div>
    )
}

export default Accessories